// To keep the log a manageable length, please limit the number of releases listed here to 5.
// If you are adding a 6th entry, please remove the oldest entry so that the total remains at 5.

const VersionLog = `

### Version 5.14.3 - April 09, 2026

- The date and time fields will now allow you to type in the values directly, and will automatically format them as you type. This should make it easier to enter values without having to use the date and time pickers.
- The date will be saved and will not block you from entering into the booking step.

### Version 5.14.2 - March 19, 2026

- The date and time fields will now allow you to type in the values directly, and will automatically format them as you type. This should make it easier to enter values without having to use the date and time pickers.

### Version 5.14.1 - November 05, 2025

- Fix behavior of Date of Birth to allow easier typing in the field.

### Version 5.14.0 - November 04, 2025

- Completely removed Out of Market from GEM.
  - If a center is selected from the drop down on the intro step, a distance of 120+ miles will no longer switch the center.
  - OOM is no longer an option within the center dropdown on the intro step under any circumstances.
  - The OOM disposition no longer exists.
  - Patient note tags related to OOM no longer exist.
  - The booking step will no longer be blocked due to Out of Market reasons.

---

### Version 5.13.1 - November 03, 2025

- Minor changes to the Medical questions regarding radiation and cancer treatment.

---

`;

export default VersionLog;
